/*
*  All the text on the site, word for word from the Wix site (www.villaportia.com). Edit here to change what the site says.
*/

export const SITE_NAME = "Villa Portia";
export const SITE_URL = "https://www.villaportia.com";
export const DEFAULT_DESCRIPTION = "Villa Portia in Bedfordview offers 5 modern, elegant self-catering rooms with en-suite bathrooms, free WiFi, Netflix, free parking, a beautiful garden and outdoor swimming pool.";

export const ROUTES = {
  HOME: "/",
  BOOK: "/book-a-room",
};

//Sections of the one-page home page. The menu links scroll to them (e.g. /#gallery)
export const SECTIONS = {
  ABOUT: "about",
  ROOMS: "rooms",
  SERVICES: "services",
  GALLERY: "gallery",
  SEE_DO: "see-do",
  CONTACT: "contact",
};

export const NAV_LINKS = [
  { label: "HOME", section: null },
  { label: "ABOUT", section: SECTIONS.ABOUT },
  { label: "ROOMS", section: SECTIONS.ROOMS },
  { label: "SERVICES", section: SECTIONS.SERVICES },
  { label: "GALLERY", section: SECTIONS.GALLERY },
  { label: "SEE & DO", section: SECTIONS.SEE_DO },
  { label: "CONTACT", section: SECTIONS.CONTACT },
];

export const CONTACT = {
  EMAIL: "Info@villaportia.com",
  PHONE: "076 616 4837",
  PHONE_LINK: "+27766164837",
  ADDRESS: "34 Arbroath Road, Bedfordview, Germiston, 2008",
  //Standard Google Maps embed / link - no API key needed
  MAP_EMBED: "https://maps.google.com/maps?q=34%20Arbroath%20Road%2C%20Bedfordview%2C%20Germiston%2C%202008&z=15&output=embed",
  MAP_LINK: "https://www.google.com/maps/search/?api=1&query=34+Arbroath+Road%2C+Bedfordview%2C+Germiston%2C+2008",
};

//Online bookings (NightsBridge property 32359, embedded on the Book A Room page as on Wix)
export const BOOKING = {
  TITLE: "Book A Room",
  DESCRIPTION: "Book a room at Villa Portia in Bedfordview online.",
  EMBED_URL: "https://book.nightsbridge.com/32359",
};

export const HOME = {
  TITLE: "HOME | Villa Portia",

  ABOUT: {
    HEADING: "ABOUT",
    TEXT: "Villa Portia impresses with its modern and elegant rooms. With 5 gorgeous rooms available, each room is beautifully furnished in a contemporary style and features a modern en-suite bathroom. All of the rooms include a range of modern amenities including flat screen TV, Streaming of Netflix and free wireless internet. We have a beautiful garden and outdoor swimming pool.",
  },

  ROOMS: {
    HEADING: "OUR ROOMS",
    TEXT: "We have 5 gorgeous rooms available in 3 different room types. Each room is beautifully furnished in a contemporary style.",
    BUTTON: "Book a Room",
  },

  SERVICES: {
    HEADING: "OUR SERVICES",
    ITEMS: [
      { icon: "catering", title: "Self Catering", text: "All rooms are Self-Catering" },
      { icon: "parking", title: "Parking", text: "Free Parking available on Site" },
      { icon: "linen", title: "Additional Linen", text: "Extra Linen and Towels available upon request (Charges apply)" },
      { icon: "wifi", title: "Free Wifi", text: "All rooms include free WiFi and streaming services" },
      { icon: "housekeeping", title: "Daily Housekeeping", text: "Housekeeping is available upon request (Charges apply)" },
      { icon: "checkin", title: "Check-In", text: "Check in is at 14:00 and\ncheck out is at 11:00" },
    ],
  },

  GALLERY: {
    HEADING: "GALLERY",
    LOAD_MORE: "Load More",
  },

  SEE_DO: {
    HEADING: "THINGS TO DO IN THE AREA",
    ITEMS: [
      { icon: "shopping", title: "East Gate Shopping Centre", text: "550m" },
      { icon: "cinema", title: "Bedford Centre", text: "950m" },
      { icon: "airport", title: "O R Tambo International Airport", text: "13km" },
      { icon: "park", title: "Gillooly’s Farm", text: "1.7km" },
    ],
  },
};

export const CONTACT_FORM = {
  HEADING: "CONTACT US",
  NAME_LABEL: "Enter Your Name",
  NAME_PLACEHOLDER: "Name",
  EMAIL_LABEL: "Enter Your Email",
  EMAIL_PLACEHOLDER: "Email",
  SUBJECT_LABEL: "Enter Your Subject",
  SUBJECT_PLACEHOLDER: "Subject",
  MESSAGE_LABEL: "Enter Your Message",
  MESSAGE_PLACEHOLDER: "Message",
  SUBMIT: "Submit",
  //Wix's default success message
  SUCCESS: "Thanks for submitting!",
};

export const FOOTER = {
  CREDIT: "Villa Portia. Proudly created by TapX",
};

//Gallery photos in the Wix order: /images/gallery/<n>.webp (full size) and /images/gallery/thumbs/<n>.webp.
//w / h are the full-size pixel sizes, used to lay out the rows. Wix had file names only - the descriptions are ours
export const GALLERY_PHOTOS = [
  { n: "01", w: 1800, h: 1200, alt: "Bedroom with a grey upholstered headboard, bistro table and chairs" },
  { n: "02", w: 1800, h: 1200, alt: "Bedroom with a bistro table, blue wardrobe and patterned rug" },
  { n: "03", w: 933, h: 1400, alt: "Shower with dark stone tiles" },
  { n: "04", w: 1800, h: 1315, alt: "Glass shower and basin" },
  { n: "05", w: 1800, h: 1200, alt: "Bed with a blue wardrobe and floor lamp" },
  { n: "06", w: 1800, h: 1200, alt: "Bed with a blue velvet headboard and wall-mounted TV" },
  { n: "07", w: 1800, h: 1200, alt: "Bed with a blue scalloped headboard and orange throw" },
  { n: "08", w: 1800, h: 1200, alt: "Close-up of the blue scalloped headboard and patterned cushions" },
  { n: "09", w: 1800, h: 1323, alt: "Bathroom with toilet and white vanity" },
  { n: "10", w: 1800, h: 1200, alt: "Palm-print cushions against a blue velvet headboard" },
  { n: "11", w: 1800, h: 1200, alt: "Bedroom with a desk, TV and blue wardrobe" },
  { n: "12", w: 1800, h: 1200, alt: "Bathroom vanity with a Villa Portia gown" },
  { n: "13", w: 1800, h: 1200, alt: "Blue wardrobe, desk and TV" },
  { n: "14", w: 1800, h: 1200, alt: "Bed with a pink headboard and orange floral cushions" },
  { n: "15", w: 1800, h: 1200, alt: "Bedroom with a pink channelled headboard" },
  { n: "16", w: 1800, h: 1220, alt: "Bathroom with a vanity basin and laundry basket" },
  { n: "17", w: 1800, h: 1180, alt: "Villa Portia branded gown" },
  { n: "18", w: 1800, h: 1200, alt: "Bedside lamp and palm-print cushions" },
  { n: "19", w: 1800, h: 1200, alt: "Bedroom with a purple velvet wingback headboard and bench" },
  { n: "20", w: 1800, h: 1200, alt: "Purple velvet wingback headboard with a bedside lamp" },
  { n: "21", w: 1800, h: 1200, alt: "Bathroom with a freestanding bath" },
  { n: "22", w: 1800, h: 1012, alt: "Kitchen with a dark splashback and pendant lights" },
  { n: "23", w: 1800, h: 1200, alt: "Grey channelled headboard with palm-print cushions" },
  { n: "24", w: 1800, h: 1200, alt: "Kitchen with navy cupboards and breakfast bar" },
  { n: "25", w: 1800, h: 1200, alt: "Bedroom with a blue velvet headboard" },
  { n: "26", w: 1800, h: 1012, alt: "Entrance hall with wooden doors and staircase" },
  { n: "27", w: 1800, h: 1139, alt: "Bright bedroom with a double bed and desk" },
  { n: "28", w: 788, h: 1400, alt: "Staircase with a wooden ceiling" },
  { n: "29", w: 1800, h: 1012, alt: "Bathroom with a claw-foot bath and shower" },
  { n: "30", w: 1800, h: 1012, alt: "Bedroom with a blue wardrobe and round rug" },
  { n: "31", w: 1800, h: 1012, alt: "Bedroom with a blue headboard and ceiling fan" },
  { n: "32", w: 1800, h: 1012, alt: "Bedroom with a ceiling fan and dark wardrobe" },
  { n: "33", w: 788, h: 1400, alt: "Shower and basin" },
  { n: "34", w: 788, h: 1400, alt: "Bathroom with a toilet and window" },
  { n: "35", w: 1800, h: 1012, alt: "Bathroom with double basins" },
  { n: "36", w: 1800, h: 1012, alt: "Bathroom with a freestanding bath and window blinds" },
  { n: "37", w: 1800, h: 1012, alt: "Lounge with bistro tables and a ceiling fan" },
  { n: "38", w: 1756, h: 900, alt: "Swimming pool, loungers and garden" },
  { n: "39", w: 1738, h: 905, alt: "Swimming pool and garden with an umbrella" },
  { n: "40", w: 1800, h: 924, alt: "View over the garden and swimming pool" },
  { n: "41", w: 1800, h: 1200, alt: "Bedroom with a blue headboard and ceiling fan" },
  { n: "42", w: 933, h: 1400, alt: "Bedroom with a grey headboard" },
  { n: "43", w: 1800, h: 1200, alt: "Desk, TV and wardrobe" },
  { n: "44", w: 1800, h: 1267, alt: "Bathroom with a bath and vanity" },
];
